import { useTranslation } from 'react-i18next';
import { FLOOR_PLANS_LAYOUT } from '../constants';

export const FloorDetail = ({ selectedBuilding, selectedSegment }) => {
  const { t } = useTranslation();
  const { totalApartments, totalElevators } =
    FLOOR_PLANS_LAYOUT[selectedBuilding];
  return (
    <div className="floor-detail-card">
      <div className="card-content">
        <div className="card-header">
          <p className="title">
            {t('floor_plan', { text: selectedBuilding.toUpperCase() })}
          </p>
          <p className="description">{t('floor', { number: '5-45' })}</p>
        </div>
        <div className="card-body">
          <div className="body-item">
            <span className="title">{t('apartment_amount')}</span>
            <span className="number">{totalApartments}</span>
          </div>
          <div className="body-item">
            <span className="title">{t('elevator_amount')}</span>
            <span className="number">{totalElevators}</span>
          </div>
          {/* <div
            className="map"
            style={{
              transform: selectedBuilding === 'vic-1' && 'scale(1, -1)',
            }}
          >
            <img
              src={mini}
              alt={`Mặt bằng toà nhà của ${selectedBuilding}-${selectedSegment}`}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};
